import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import { useCurrentAccountId } from '@zapier/design-system-revenue/src/hooks';

import { currentAccount as CurrentAccountData } from './types/currentAccount';

export const CURRENT_ACCOUNT = gql`
  query currentAccount($accountId: Int!) {
    account(id: $accountId) {
      id
      enabledTrialExtensions
      isPaying
    }
  }
`;

export const useCurrentAccount = () => {
  const { accountId } = useCurrentAccountId();

  const { data, loading, error } = useQuery<CurrentAccountData>(
    CURRENT_ACCOUNT,
    {
      skip: !accountId,
      variables: {
        accountId,
      },
    }
  );

  return {
    currentAccount: data?.account,
    isLoading: loading,
    error: error
      ? 'There was an error fetching account information. Please try again.'
      : null,
  };
};
